import { create } from 'zustand';

const COLLAPSED_KEY = 'orbita.sidebar.collapsed';

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

interface ShellState {
  sidebarCollapsed: boolean;
  mobileNavOpen: boolean;
  paletteOpen: boolean;
  menuEditorOpen: boolean;
  toggleSidebar: () => void;
  setMobileNavOpen: (open: boolean) => void;
  setPaletteOpen: (open: boolean) => void;
  setMenuEditorOpen: (open: boolean) => void;
}

export const useShellStore = create<ShellState>()((set, get) => ({
  sidebarCollapsed: readCollapsed(),
  mobileNavOpen: false,
  paletteOpen: false,
  menuEditorOpen: false,
  toggleSidebar: () => {
    const next = !get().sidebarCollapsed;
    try {
      localStorage.setItem(COLLAPSED_KEY, next ? '1' : '0');
    } catch {
      // Preference is kept for this session only.
    }
    set({ sidebarCollapsed: next });
  },
  setMobileNavOpen: (mobileNavOpen) => set({ mobileNavOpen }),
  setPaletteOpen: (paletteOpen) => set({ paletteOpen }),
  setMenuEditorOpen: (menuEditorOpen) => set({ menuEditorOpen }),
}));
